'use client';

import { cx } from '@onbeam/business-styled-system/css';
import { hstack, text, vstack } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { ComponentProps } from 'react';
import { HeroVideo } from './HeroVideo';
import { breakout } from '@/styles';
import { token } from '@onbeam/business-styled-system/tokens';
import { useBreakpoint } from '@onbeam/utils';

export const Hero = ({ className, ...props }: ComponentProps<'section'>) => {
  const isMobile = useBreakpoint({ max: token('breakpoints.md') });

  return (
    <section
      className={cx(
        breakout(),
        vstack({
          gap: { base: '20', md: '24' },
          maxW: '[70rem]',
          align: 'center',
        }),
        className,
      )}
      {...props}
    >
      <div
        className={vstack({
          gap: '10',
          align: 'center',
          textAlign: 'center',
          mdDown: {
            px: '6',
            gap: '8',
          },
        })}
      >
        <h1
          className={text({
            maxW: '[44rem]',
            style: { base: 'subtitle-lg', md: 'headline-lg' },
          })}
        >
          Beam Ventures is a frontier technology fund.
        </h1>
        <p
          className={text({
            style: { base: 'body-md', md: 'body-lg' },
            maxW: '[32rem]',
          })}
        >
          We believe Web3 infrastructure, tooling, and consumer products will
          power the next generation of the digital economy.
        </p>
        <div className={hstack({ gap: '2', md: { gap: '4' } })}>
          <Button
            as="a"
            href="mailto:contact@beamventures.com"
            size={isMobile ? 'md' : 'lg'}
          >
            Contact Us
          </Button>
          {/* TODO: Place back once approved by Legal */}
          {/* <Button
            as="a"
            href="https://form.typeform.com/to/xHcCkx8o"
            target="_blank"
            rel="noopener noreferrer"
            size={isMobile ? 'md' : 'lg'}
          >
            Apply as a founder
          </Button>
          <Button
            as="a"
            href="https://form.typeform.com/to/w7AQJtSP"
            target="_blank"
            rel="noopener noreferrer"
            size={isMobile ? 'md' : 'lg'}
            variant="secondary"
          >
            Partner with us
          </Button> */}
        </div>
      </div>
      <HeroVideo />
    </section>
  );
};
